export default {
    "name": "UpdateItinerariesFavorite",
    "kind": "HoudiniMutation",
    "hash": "ce91f25994cf0f30ab7b3666d569279671f37a4ad467757eb9c2d42851b200b9",

    "raw": `mutation UpdateItinerariesFavorite($input: UpdateItinerariesFavoriteInput!) {
  updateItinerariesFavorite(input: $input) {
    itinerariesFavorites {
      coordinates {
        lat
        lng
      }
      mode
      currency
      distanceSystem
      departureName
      arrivalName
      steps
      isEv
      withCaravan
      constraints
      duration
      distance {
        value
        unit
      }
      totalCost {
        amount
        currency
      }
      timestamp
      carId
    }
  }
}`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateItinerariesFavorite": {
                "type": "User",
                "keyRaw": "updateItinerariesFavorite(input: $input)",

                "selection": {
                    "fields": {
                        "itinerariesFavorites": {
                            "type": "ItineraryFavorite",
                            "keyRaw": "itinerariesFavorites",

                            "selection": {
                                "fields": {
                                    "coordinates": {
                                        "type": "Coordinates",
                                        "keyRaw": "coordinates",

                                        "selection": {
                                            "fields": {
                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                },

                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "mode": {
                                        "type": "ItineraryTravelMode",
                                        "keyRaw": "mode",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    },

                                    "distanceSystem": {
                                        "type": "DistanceSystem",
                                        "keyRaw": "distanceSystem",
                                        "visible": true
                                    },

                                    "departureName": {
                                        "type": "String",
                                        "keyRaw": "departureName",
                                        "visible": true
                                    },

                                    "arrivalName": {
                                        "type": "String",
                                        "keyRaw": "arrivalName",
                                        "visible": true
                                    },

                                    "steps": {
                                        "type": "String",
                                        "keyRaw": "steps",
                                        "visible": true
                                    },

                                    "isEv": {
                                        "type": "Boolean",
                                        "keyRaw": "isEv",
                                        "visible": true
                                    },

                                    "withCaravan": {
                                        "type": "Boolean",
                                        "keyRaw": "withCaravan",
                                        "visible": true
                                    },

                                    "constraints": {
                                        "type": "ItineraryConstraint",
                                        "keyRaw": "constraints",
                                        "visible": true
                                    },

                                    "duration": {
                                        "type": "Int",
                                        "keyRaw": "duration",
                                        "visible": true
                                    },

                                    "distance": {
                                        "type": "Distance",
                                        "keyRaw": "distance",

                                        "selection": {
                                            "fields": {
                                                "value": {
                                                    "type": "Float",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                },

                                                "unit": {
                                                    "type": "DistanceUnit",
                                                    "keyRaw": "unit",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "totalCost": {
                                        "type": "Price",
                                        "keyRaw": "totalCost",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Float",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currency": {
                                                    "type": "String",
                                                    "keyRaw": "currency",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "timestamp": {
                                        "type": "Float",
                                        "keyRaw": "timestamp",
                                        "visible": true
                                    },

                                    "carId": {
                                        "type": "String",
                                        "keyRaw": "carId",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "UpdateItinerariesFavoriteInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "DistanceInput": {
                "unit": "DistanceUnit",
                "value": "Float"
            },

            "PriceInput": {
                "amount": "Float",
                "currency": "Currency"
            },

            "UpdateItinerariesFavoriteInput": {
                "arrivalName": "String",
                "carId": "String",
                "constraints": "ItineraryConstraint",
                "coordinates": "CoordinatesInput",
                "departureName": "String",
                "distance": "DistanceInput",
                "duration": "Int",
                "isEv": "Boolean",
                "mode": "ItineraryTravelMode",
                "steps": "String",
                "totalCost": "PriceInput",
                "withCaravan": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=b7b1df2d8460e2fcdfd730ad554723a877e7697233b294e2281ad9b8de879f2f";